const FARO_EVENT = {
    PostMessageError: "sso-post-message-error",
    PostMessageSent: "sso-post-message-sent",
    SilentAuthPostMessageError: "sso-silent-auth-post-message-error",
    SilentAuthPostMessageSent: "sso-silent-auth-post-message-sent",
    PageDiscarded: "sso-page-was-discarded",
    WindowOpenerError: "sso-window-opener-error",
    WindowOpenerCapturedFromSdkPing: "sso-window-opener-provider",
    FormValidationFailed: "sso-form-validation-failed",
    InlineSignInPostMessageSent: "sso-post-message-inline-sign-in",
    InlineSignInMetadataRetrieved: "sso-inline-sign-in-metadata-retrieved",
    InlineSignInMetadataError: "sso-inline-sign-in-metadata-error",
    GmailLinkToOtpEmailClicked: "sso-gmail-link-to-otp-email-clicked",
    PasskeyAssertionOptionsFetched: "sso-passkey-assertion-options-fetched",
    PasskeyAssertionOptionsFetchError: "sso-passkey-assertion-options-fetch-error",
    PasskeyAutofilled: "sso-passkey-autofilled",
    PasskeyAutofillError: "sso-passkey-autofill-error",
    PasskeyAutofillNotSupported: "sso-passkey-autofill-not-supported",
    PasskeyAuthCredentialSelected: "sso-passkey-auth-credential-selected",
    PasskeyAuthCredentialSelectionError: "sso-passkey-auth-credential-selection-error",
    PasskeyAuthPageClosed: "sso-passkey-auth-page-closed",
    PasskeyRegistrationCredentialCreated: "sso-passkey-registration-new-credential-created",
    PasskeyRegistrationCredentialCreationError: "sso-passkey-registration-new-credential-creation-error",
    PasskeyRegistrationPageClosed: "sso-passkey-registration-page-closed",
    HpSubmissionAttempt: "sso-hp-submission-attempt",
};
export const FARO_INIT_ATTRIBUTE = {
    SessionId: "sessionId",
    TraceId: "traceId",
    ClientId: "clientId",
    AccountId: "accountId",
    Environment: "environment",
    AsyncInit: "asyncInit",
    TemplateName: "templateName",
};
